module.exports = __webpack_public_path__ + "img/image (19).1c5887e2.webp";